import React, { useContext, useEffect, useState } from 'react';
import { UserI } from '../types/UserI';

import { BiShow, BiHide } from "react-icons/bi";

import content from '../languages/LogInForm.json'
import PageContext from '../global_state/context/PageContext';
import { PageType } from '../types/PageI';

import SCSS from '../assets/scss/Form.module.scss'
import APP_SCSS from '../assets/scss/App.module.scss'
import Title from './Title';
import LogInUserService from 'services/user_services/LogInUserService';
import UserContext from 'global_state/context/UserContext';

function LogInForm() {
    const {dispatchUser} = useContext(UserContext)
    const {page, dispatchPage}  = useContext(PageContext)

    const [user_name, setUserName] = useState("")
    const [password, setPassword] = useState("")
    const [password_visibility, setPasswordVisibility] = useState(false)
    


    let language = page.settings.language
    
    const [log_in_response, setResponse] = useState<string | UserI>()    

    const isPasswordStrongEnought = (password: string): boolean => {
        if (password.length < 8) {
            dispatchPage({
                type: "add_notification",
                payload: {
                    notification: {
                        type: "error",
                        message: "weak_password"
                    }
                }
            }) 
            return false
        }
        return true
    }

    const handleSubmit = async (event) => {
        setResponse(undefined)
        event.preventDefault()
        
        // if (!isPasswordStrongEnought(password)) {
        //     return 
        // }
        // console.log(password);
        
        setResponse(await LogInUserService(user_name, password))
    }

    const handleForgottenPasswordClick = (e) => {
        e.preventDefault()
        dispatchPage({type: "render", payload: {page: PageType.forgotton_password}})
        return false;
    }

    useEffect(() => {
        
        if (page.props && 'from_page' in page.props) {
            // console.log(page.props);    
            dispatchPage({
                type: "add_notification",
                payload: {
                    notification: {
                        type: "warning",
                        message: "online_account_exist_error"
                    }
                }
            })
        }
        
    }, [])

    useEffect(() => {
        
        if (typeof log_in_response === 'string') {
            // console.log(log_in_response);
            dispatchPage({
                type: "add_notification",
                payload: {
                    notification: {
                        type: "error",
                        message: log_in_response
                    }
                }
            }) 
            return 
        }

        if (typeof log_in_response == 'object' && 'client_id' in log_in_response){
            // triggerUserEvent()
            dispatchUser({type: "log_in", payload: log_in_response})       
            dispatchPage({type: "render", payload: {page: PageType.user_profile}})
        }


        
        }, [log_in_response, dispatchUser, dispatchPage]);

    return (
        <div className={[SCSS.Form_SCSS].join("")}>
            
            {/* <div>{(typeof log_in_response == 'string') ? log_in_response : ""}</div> */}
            
            <Title back_arrow={true} title={content[language].title_text} page={PageType.entrance} ></Title>
            <form className={SCSS.form} onSubmit={(e) => {handleSubmit(e)}}>
                <div className={SCSS.info_text}>{content[language].title_sub}</div>

                <label className={SCSS.label} htmlFor="user_name">
                    <input 
                        className={SCSS.input}
                        placeholder={content[language].input_user_name_placeholde} onChange={(e) => {setUserName(e.target.value)}} type="text" name="user_name" id="user_name" value={user_name} />
                </label>
                <label className={SCSS.label} htmlFor="password">
                    <input 
                        className={SCSS.input}
                        placeholder={content[language].input_user_password_placeholder} onChange={(e) => {setPassword(e.target.value)}} type={(password_visibility) ? "text" : "password"} name="password" id="password" value={password} />
                    <div onClick={() => setPasswordVisibility(!password_visibility)} className={SCSS.password_visibility}>
                        {(password_visibility) ? 
                            <BiShow/> : <BiHide/>}
                    </div>
                </label>
                <button
                    className={[APP_SCSS.button, APP_SCSS.red].join(" ")}
                    type='submit'>{content[language].submit_button}</button>
                <div className={SCSS.forgotten_password}><a href="" onClick={(event) => {return handleForgottenPasswordClick(event)}}>{content[language].forgotten_password}</a></div>
            </form>
        </div>
    );
}


export default LogInForm